module.exports = __webpack_public_path__ + "static/media/om_eyeshape_hooded_grey.cd9ade03.png";